import React, { useState, useContext } from 'react';
import Swal from "sweetalert2";
import logo from "../../assets/Grupo.png"
import styles from "../login/login.module.css";
import { api } from "../../services/api";
import Spinner from '../../components/spinner';

import { useNavigate } from "react-router-dom"

export default function Reset() {
  const navigate = useNavigate()

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState([])

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    timerProgressBar: true,
    showConfirmButton: false,
    timer: 3000,
    width: 400,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  async function onSubmit() {
    try {
      setLoading(true)
      let response = await api.post('reset', {
        "email": email,
      })

      if (response.status == 200) {
        Swal.fire({
          title: 'Alteração de senha',
          text: "Um link foi enviado para seu e-mail. Após o recebimento, sua validade é de 12 horas.",
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#46B8D3',
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/";
          }
        })
      }
    } catch (err) {
      console.log(err.response.data.toString(), 'Requisição ja efetuada, verifique seu email')
      if (err.response.data == 'Requisição ja efetuada, verifique seu email.') {
        Swal.fire({
          title: 'Alteração de senha',
          text: "Um link já foi enviado para seu e-mail. Por favor verifique sua caixa de e-mails e spam. Somente é possível solicitar um novo link após o período de expiração de 12 horas.",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#46B8D3',
          confirmButtonText: 'Ok'
        })
      } else {
        Toast.fire({
          icon: 'error',
          title: `${err.response.data.toString()}`
        })
      }
    }
    setLoading(false)
  }



  return (
    <>
      {loading == true ? (
        <div className="spinner">
          <Spinner animation="border" />
        </div>
      ) : (
        <div></div>)}
      <div className={styles.main}>
        <div className={styles.containerHome}>
          <img alt='logo' src={logo} />
          <div className={styles.containerButtons}>
            <div className={styles.title}>
              <span className={styles.titleFirst}>Catálogo de</span>
              <span className={styles.titleFirst}><strong>Produtos Químicos</strong></span>
            </div>
            <div className={styles.loginright}>
              <h1>Reset de senha</h1>
              <div className={styles.inputsContainer}>
                <p>Email:</p>
                <div>
                  <input type="text"
                    name="email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                </div>
              </div>
              <div className={styles.buttons}>
                <button className={styles.divButton} onClick={() => onSubmit()} > Enviar </button>
                <button className={styles.divButtonRegister} onClick={() => window.location.href = "/"}> Login </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}